import type { PaletteOptions } from '@mui/material/styles';

// Paleta DPV (extraída del manual de marca)
export const dpvColors = {
  violeta: {
    main: '#5A1C70',
    dark: '#3D1350',
    medium: '#7B3493',
    light: '#B589C4',
    veryLight: '#EFE5F2',
  },
  naranja: {
    main: '#FF7300',
    dark: '#CC5C00',
    light: '#FFA64D',
    veryLight: '#FFE9D6',
  },
  neutros: {
    textoPrincipal: '#1A1A1A',
    textoSecundario: '#4D4D4D',
    fondoClaro: '#FAFAFA',
    fondoTabla: '#F5F5F5',
    border: '#E0E0E0',
  },
} as const;

// Colores para el gráfico de torta de coprocultivo (FIJO según AGENT.md del backend)
export const coprocultivoColors = {
  ostertagia: '#5A1C70',
  trichostrongylus: '#FF7300',
  cooperia: '#2D7A8C',
  haemonchus: '#A93F3F',
  oesophagostomum: '#D9A441',
  nematodirus: '#9B6B9E',
} as const;

// Module augmentation so TypeScript recognises the custom palette variants
declare module '@mui/material/styles' {
  interface PaletteColor {
    veryLight?: string;
    medium?: string;
  }
  interface SimplePaletteColorOptions {
    veryLight?: string;
    medium?: string;
  }
}

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: dpvColors.violeta.main,
    dark: dpvColors.violeta.dark,
    light: dpvColors.violeta.light,
    medium: dpvColors.violeta.medium,
    veryLight: dpvColors.violeta.veryLight,
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: dpvColors.naranja.main,
    dark: dpvColors.naranja.dark,
    light: dpvColors.naranja.light,
    veryLight: dpvColors.naranja.veryLight,
    contrastText: '#FFFFFF',
  },
  text: {
    primary: dpvColors.neutros.textoPrincipal,
    secondary: dpvColors.neutros.textoSecundario,
  },
  background: {
    default: dpvColors.neutros.fondoClaro,
    paper: '#FFFFFF',
  },
  divider: dpvColors.neutros.border,
  success: { main: '#2E7D32' },
  warning: { main: '#ED6C02' },
  error: { main: '#D32F2F' },
  info: { main: '#0288D1' },
};
